import { ethers } from 'ethers';
import { Dispatch, SetStateAction, useEffect, useState } from 'react';

export function useSigner(
  provider: ethers.providers.Web3Provider | null
): [ethers.Signer | null, Dispatch<SetStateAction<ethers.Signer | null>>] {
  const [signer, setSigner] = useState<ethers.Signer | null>(null);

  useEffect(() => {
    if (!provider) return;
    setSigner(provider.getSigner());
  }, [provider]);

  return [signer, setSigner];
}
